import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface SectionCardProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
  actions?: ReactNode;
}

export default function SectionCard({ title, subtitle, children, className, actions }: SectionCardProps) {
  return (
    <section className={cn('bg-white rounded-2xl p-6 shadow-card-sm', className)}>
      {(title || actions) ? (
        <div className='flex items-start justify-between gap-4 mb-4'>
          <div>
            {title ? <h2 className='font-semibold text-apple-near-black text-[1.125rem]'>{title}</h2> : null}
            {subtitle ? <p className='text-apple-gray text-[0.875rem] mt-1'>{subtitle}</p> : null}
          </div>
          {actions ? <div>{actions}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
